

import { sliceText, removeSpecialCharAndNumFn } from "../../../utils/common";
import { safeString } from "../../../utils/logger";




const today = new Date();
    
// Set the max date to December 31 of the current year
today.setMonth(11);  // December (0-based index, so 11 is December)
today.setDate(31);   // Set the day to 31

// Format date as YYYY-MM-DD
const formattedDate = today.toISOString().split('T')[0];
   

const minDateObj = new Date(today.getFullYear(), 0, 1); // January 1st of the current year
const minFormattedDate = minDateObj.toISOString().split('T')[0]; 


export const HOLIDAY_INITIAL_STATE={
  holidayDate:"",
  holidayName:""

}
export const HOLIDAY_INPUT_FIELDS = {

  holidayDate: {
    name: "holidayDate",
    label: "Date",
    type: "date",
    placeholder: "Type Here...",
    fullWidth: true,
    required:true,
    max:formattedDate,
  
            valueSinc:true,

min:minFormattedDate,
onKeyDown:e=>e.preventDefault()

  },
  holidayName: {
    name: "holidayName",
    label: "Holiday Name",
    type: "text",
    placeholder: "Type Here...",
   
    fullWidth: true,
    required:true,
  
        
        
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeSpecialCharAndNumFn(safeString(value)),150);
       return value;
     }
      
      }

  },
};


export const HOLIDAY_API={
  HOLIDAY_CREATE:{url:"/holiday/", method:"POST"},
  HOLIDAY_UPDATE:{url:"/holiday/", method:"PUT"},
  HOLIDAY_DELETE:{URL:"/holiday/", METHOD:"DELETE"},
  HOLIDAY_LIST:{URL:"/holiday/", METHOD:"GET"},
  MASTER_HOLIDAY_LIST:{URL:"/holiday/admin/master", METHOD:"GET"},
  
  };
